import React, { useState, useEffect } from "react";
import RadioButton from "ui-coopeuch-radio-button";
import IconArrowBottom from "./icon-arrow-bottom.svg";
import IconArrowTop from "./icon-arrow-top.svg";

import "./collapse.css";

const CollapseItem = props => {
  const {
    title,
    indicatorLabel,
    switchIndicatorLabel,
    children,
    onCollapse,
    isCollapsed,
    handleCuenta,
    index,
    esCollapsable,
    appBloquedaCollapse,
    cpEStadoCollapse,
    codigoCollapse,
    tcooStadoCollapse,
  } = props;

  const [ishashtag] = useState({
    nombre: 'Bloqueado',
    color: '#BF0238'
  })

  const [localControlIsCollapsed, setLocalControIsCollapsed] = useState(isCollapsed);

  const Hashtag = () => {
    return (
      <span className="etiqueta" style={{ backgroundColor: ishashtag.color }}>{ishashtag.nombre}</span>
    )
  }


  useEffect(() => {
    if (isCollapsed) setLocalControIsCollapsed(isCollapsed);
  }, [isCollapsed]);

  useEffect(() => {
    if (onCollapse) onCollapse(localControlIsCollapsed);
  }, [localControlIsCollapsed]);


  return (
    <section className="AccordionItem" id="collapseCard">
      <button
        className={`AccordionItem--header ${ esCollapsable ? "AccordionItem--header__content-expanded" : "" }`}
        type="button"
        onClick={() => handleCuenta(index,title)}
        
      >
        <hgroup>
          <RadioButton name="radioButton" label={title} value={title} isChecked={esCollapsable} />
          {appBloquedaCollapse || cpEStadoCollapse === 2 || tcooStadoCollapse === 2 || codigoCollapse === "11" ? <Hashtag /> : ""}

        </hgroup>
        <article className="AccordionItem--collapsed-indicator">
          { esCollapsable ? (
            <>
              {switchIndicatorLabel}
              <img src={IconArrowTop} alt="arrow-bottom" />
            </>
            ) : (
              <>
                {indicatorLabel}
                <img src={IconArrowBottom} alt="arrow-top" />
              </>
            )}
        </article>
      </button>

      {esCollapsable && (
        <section className="AccordionItem--content">{children}</section>
      )}
    </section>
  );
};

export default CollapseItem;
